import {useContext} from 'react';
import {LocalizationContext} from 'epic-localization/src/context/LocalizationContext';
import {getMessage} from 'epic-localization/src/utils/messageCode';

const useLocalization = () => {
    const context = useContext(LocalizationContext);

    // @ts-ignore
    return (code: string, args?: (string | number)[]) => getMessage(context.messages, code, args);
};

export default useLocalization;
